import { render } from "./MobileNavbar.vue?vue&type=template&id=edb37258&ts=true"
import script from "./MobileNavbar.vue?vue&type=script&lang=ts"
export * from "./MobileNavbar.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__